/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileXblrTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M3 2h18v8h-2V6H5v14h14v-1h2v3H3V2z" fill="currentcolor" />
      <path
        d="M8.307 14.474 6.807 17h1.152l1.045-1.843L10.09 17h1.2l-1.51-2.506 1.434-2.365h-1.152l-.979 1.682-1.005-1.682H6.88l1.427 2.345zm3.515-2.345v4.87h1.748c1.318 0 1.977-.475 1.977-1.426 0-.585-.288-.967-.865-1.146.206-.103.367-.241.483-.415a1.04 1.04 0 0 0 .174-.59c0-.442-.147-.768-.442-.978-.29-.21-.746-.315-1.367-.315h-1.708zm1.514 2.017h-.51v-1.22h.51c.357 0 .607.047.75.14.143.09.215.249.215.477 0 .219-.074.375-.222.469-.142.089-.39.134-.743.134zm.154 2.05h-.663v-1.307h.663c.344 0 .596.052.757.154.16.103.241.266.241.49 0 .227-.08.395-.241.502-.16.107-.413.16-.757.16zm2.709.804v-4.871h1.87c.58 0 1.027.134 1.34.402.312.268.468.648.468 1.139 0 .344-.09.636-.268.878a1.416 1.416 0 0 1-.744.515L20.085 17h-1.153l-1.031-1.749-.664-.167V17H16.2zm1.038-2.6h.51c.406 0 .687-.051.844-.154.16-.107.24-.293.24-.556 0-.263-.08-.447-.24-.55-.157-.107-.438-.16-.845-.16h-.509v1.42zm3.378-2.271v4.87h3.19v-.93H21.66v-3.94h-1.045z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileXblrTemplate as FileXblrTemplate };
